import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { MailOpen } from "lucide-react";
import Card from "../../../components/ui/Card";
import ActivityAction from "../../../actions/ActivityAction";

const EmailCard = ({ activity }: { activity: any }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);

  const contentRef = useRef(null);

  const title = activity.getIn(["event", "data", "summary"]) || t("Email");
  const description = activity.getIn(["event", "data", "description"]) || "";

  useEffect(() => {
    if (contentRef.current) {
      const lineHeight = parseFloat(window.getComputedStyle(contentRef.current).lineHeight);
      const maxHeight = lineHeight * 3;
      setShowToggle(contentRef.current.scrollHeight > maxHeight);
    }
  }, [description]);

  return (
    <Card className="overflow-hidden w-full h-full">
      <div className="p-2 w-full space-y-2">
        <div
          className="w-full flex gap-2 items-center cursor-pointer"
          // title={title}
          onClick={() => {
            dispatch(ActivityAction.showActivityDialog(activity.get("itemId"), activity.get("id")));
          }}
        >
          <MailOpen className="w-4 h-4 text-gray-600 shrink-0" />
          <div className="text-sm font-semibold text-gray-900">{title}</div>
        </div>
        <div>
          <div
            ref={contentRef}
            className={`
              wrap-anywhere
              transition-all
              duration-300
              overflow-hidden
              ${expanded ? "" : "line-clamp-3"}
            `}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {showToggle && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                setExpanded(!expanded);
              }}
              className="mt-2 text-xs font-medium text-blue-600 hover:text-blue-800 transition cursor-pointer"
            >
              {expanded ? t("Show less") : t("Show more")}
            </button>
          )}
        </div>
      </div>
    </Card>
  );
};

export default EmailCard;
